<template>
  <div v-if="isLoading">
    <LoaderIcon></LoaderIcon>
  </div>
  <div
    v-else
    :style="
      clientStore.getCustomBackgroundImagePath !== null
        ? 'background-image: url(' +
          clientStore.getCustomBackgroundImagePath +
          '); '
        : ''
    "
    :class="{
      'custom-background-image':
        clientStore.getCustomBackgroundImagePath !== null,
    }"
  >
    <BackgroundBubbles
      v-if="clientStore.getCustomBackgroundImagePath === null"
    />
    <div
      class="max-w-7xl mx-auto flex px-4 sm:px-6 lg:px-8 py-12 z-20 flex-col"
      :class="
        isCampaignExpired ? 'min-h-screen justify-start' : 'justify-center'
      "
    >
      <h2 class="textHeadline2 text-white mb-8">Registrieren</h2>
      <div
        v-if="isCampaignExpired"
        class="block md:flex flex-col lg:flex-row justify-center basis-1/2 justify-center gap-6"
      >
        <h1 class="text-4xl text-red-800">
          {{ $t("ssosbk.register.error.campaignExpired") }}
        </h1>
      </div>
      <div
        v-else
        class="block md:flex flex-col lg:flex-row justify-center basis-1/2 justify-center gap-6"
      >
        <div
          class="w-full shadow lg:overflow-hidden rounded-md bg-white space-8 px-8 basis-1/2"
        >
          <registration-form
            id="formDataRegistrationNew"
            ref="formNew"
            :form="formDataRegistrationNew"
            :error="error"
            title="Neuer Account"
            @submit-register="
              (form) => {
                submitFormNew(form);
              }
            "
          />
        </div>
        <div
          class="w-full shadow lg:overflow-hidden rounded-md bg-white space-y-8 basis-1/2"
        >
          <registration-form
            id="formDataRegistrationExisting"
            ref="formExisting"
            :form="formDataRegistrationExisting"
            :title="$t('ssosbk.register.existing.title')"
            @submit-register="
              (form) => {
                submitFormExisting(form);
              }
            "
          ></registration-form>
        </div>
      </div>
    </div>
  </div>
  <FooterLinks v-if="isCampaignExpired" bg-fixed position-fixed />
  <FooterLinks v-else bg-fixed />
</template>

<script>
import LoaderIcon from "../../../components/v2/loader/LoaderIcon.vue";
import BackgroundBubbles from "../../../components/v2/layout/BackgroundBubbles";
import {
  fetchForm,
  sendRegistrationNewAccount,
  sendRegistrationExistingAccount,
} from "~/api/sbk";
import RegistrationForm from "../../../components/v2/sbk/RegistrationForm";
import FooterLinks from "../../../components/v2/sbk/FooterLinks.vue";
import { useClientStore } from "../../../store/v2/client";
import { useUserStore } from "../../../store/v2/user";
import { SBK_BLUE } from "../../../enum/v2/sbk";

export default {
  name: "SbkRegisterPage",
  components: {
    FooterLinks,
    RegistrationForm,
    BackgroundBubbles,
    LoaderIcon,
  },
  setup() {
    const clientStore = useClientStore();
    const userStore = useUserStore();
    return {
      clientStore,
      userStore,
    };
  },
  data() {
    return {
      client: null,
      isLoading: Boolean,
      isCampaignExpired: false,
      formDataRegistrationNew: [],
      formDataRegistrationExisting: [],
      formDataRegistrationExistingError: null,
      error: [],
    };
  },
  async mounted() {
    if (this.$userAuthenticator.isAuthorized()) {
      await this.userStore.getUser();
    }

    this.clientStore.setAtmCampaign(this.$route.params.atmCampaign);
    this.clientStore.setPasswordResetRedirectTarget("register");
    this.clientStore.setClientColorsManually(
      SBK_BLUE,
      SBK_BLUE,
      SBK_BLUE,
      SBK_BLUE,
      SBK_BLUE
    );

    this.client = await this.clientStore.getClient(
      null,
      this.$route.params.atmCampaign,
      true
    );

    if (
      this.client &&
      this.client.isMaintenance &&
      this.userStore.getCanBypassMaintenance !== true
    ) {
      this.redirectToMaintenance();
    }

    fetchForm(this.$route.params.atmCampaign)
      .then((form) => {
        if (form.data) {
          this.formDataRegistrationNew = form.data.registrationNew;
          this.formDataRegistrationExisting = form.data.registrationExisting;
        }

        this.isLoading = false;
      })
      .catch((error) => {
        // campaign has expired
        if (error.response && error.response.status === 410) {
          this.isCampaignExpired = true;
          this.isLoading = false;
        } else {
          // redirect to maintenance page if request fails
          return this.$router.push({
            name: "maintenancePage",
          });
        }
      });
  },
  methods: {
    redirectToMaintenance() {
      this.$router.push({
        name: "maintenancePage",
      });
    },
    async submitFormNew(form) {
      sendRegistrationNewAccount(form)
        .then((response) => {
          this.clientStore.setSlug(response.data.client_slug);
          this.$router.push({
            name: "sbkRegisterSuccess",
          });
        })
        .catch((error) => {
          if (
            error.response.data.errorType !== undefined &&
            error.response.data.errorType ===
              "alreadyRegisteredForRunningCampaign"
          ) {
            this.error[0] = this.$t(
              "ssosbk.register.error.alreadyRegisteredForExistingCampaign"
            );
          } else if (
            error.response.data.errorType !== undefined &&
            error.response.data.errorType === "alreadyRegisteredForThisCampaign"
          ) {
            this.error[0] = this.$t(
              "ssosbk.register.error.alreadyRegisteredForThisCampaign"
            );
          } else if (error.response.data.message === "email already in use") {
            this.error[0] = this.$t("ssosbk.register.error.text");
          } else if (
            error.response.data.errorType !== undefined &&
            error.response.data.errorType === "campaignHasNotYesStarted"
          ) {
            this.error[0] = this.$t(
              "ssosbk.register.error.campaignHasNotYesStarted"
            );
          }

          if (error.response.status === 400 && error.response.data.fields) {
            this.formDataRegistrationNew = error.response.data.fields;

            // Add hint for telephone field to error message
            const telephoneFieldErrorIndex =
              this.getArrayIndexForErrorFormField(
                this.formDataRegistrationNew,
                "tel"
              );

            if (
              telephoneFieldErrorIndex !== null &&
              this.formDataRegistrationNew[telephoneFieldErrorIndex].error !==
                null
            ) {
              this.formDataRegistrationNew[telephoneFieldErrorIndex].error +=
                " " + this.$t("ssosbk.register.televisionHint");
            }

            // Needs to be async to first set errorMessages in components
            setTimeout(() => {
              this.$refs.formNew.scrollToError();
            }, 200);
          } else if (error.response.status === 500) {
            this.$router.push({
              name: "maintenancePage",
            });
          }
        });
    },
    async submitFormExisting(form) {
      const responseR = sendRegistrationExistingAccount(form)
        .then((response) => {
          this.clientStore.setSlug(response.data.client_slug);
          this.$router.push({
            name: "sbkRegisterSuccess",
          });
        })
        .catch((error) => {
          if (
            error.response.data.errorType != undefined &&
            error.response.data.errorType ===
              "alreadyRegisteredForRunningCampaign"
          ) {
            this.formDataRegistrationExisting[0].error = this.$t(
              "ssosbk.register.error.alreadyRegisteredForExistingCampaign"
            );
          } else if (
            error.response.data.errorType != undefined &&
            error.response.data.errorType === "alreadyRegisteredForThisCampaign"
          ) {
            this.formDataRegistrationExisting[0].error = this.$t(
              "ssosbk.register.error.alreadyRegisteredForThisCampaign"
            );
          } else if (
            error.response.data.errorType != undefined &&
            error.response.data.errorType === "campaignHasNotYesStarted"
          ) {
            this.formDataRegistrationExisting[0].error = this.$t(
              "ssosbk.register.error.campaignHasNotYesStarted"
            );
          } else if (error.response.status === 400) {
            this.formDataRegistrationExisting[0].error = this.$t(
              "ssosbk.register.existing.loginFailed"
            );

            // Needs to be async to first set errorMessages in components
            setTimeout(() => {
              this.$refs.formExisting.scrollToError();
            }, 200);
            this.formDataRegistrationExistingError = error.response;
          } else if (error.response.status === 500) {
            this.$router.push({
              name: "maintenancePage",
            });
          }
        });
    },
    getArrayIndexForErrorFormField(form, fieldName) {
      for (let i = 0; i < form.length; i++) {
        if (form[i].name === fieldName) {
          return i;
        }
      }

      return null;
    },
  },
};
</script>
<style>
::placeholder {
  color: lightgray !important;
}

.input-primary[type="text"],
.input-primary[type="email"],
textarea.input-primary,
.input-primary[type="datetime-local"],
.input-primary[type="date"],
.input-primary[type="password"],
.input-primary[type="number"],
select.input-primary {
  color: v-bind("SBK_BLUE");
}
</style>
